var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownloadFile = function SvgDownloadFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1C1919",
    fillRule: "evenodd",
    d: "M18.375 8.567v8.98H1.63v-8.98h1.288v7.834h14.169V8.567zm-3.624.405L10.002 13.2 5.253 8.972l.911-.81 3.194 2.842V2.454h1.288v8.552l3.195-2.843z",
    clipRule: "evenodd"
  })));
};
export default SvgDownloadFile;